import "./App.css";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import Main from "./Component/Main";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaymentResult from "./Component/SuccessPay";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import { PolicyCenter, PolicyDocument, RoutedPolicyPage } from "./Component/PolicyPage";
import { policyMap } from "./policies";

const aliases = [["privacy", "privacy"], ["terms", "terms"], ["shipping", "shipping"], ["returns", "returns"], ["faq", "faq"], ["cookies", "cookies"]];

function App() {
  return <CartProvider><Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}><Header /><Routes>
    <Route path="/" element={<Main />} />
    <Route path="/about" element={<About />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/shop" element={<Shop />} />
    <Route path="/shopDetails/:id" element={<ProductDetail />} />
    <Route path="/product/:id" element={<ProductDetail />} />
    <Route path="/cartpage" element={<CartPage />} />
    <Route path="/checkout" element={<CheckOut />} />
    <Route path="/payment" element={<PaymentResult />} />
    <Route path="/paysuccess" element={<Navigate to="/payment" replace />} />
    <Route path="/policies" element={<PolicyCenter />} />
    <Route path="/policies/:slug" element={<RoutedPolicyPage />} />
    {aliases.map(([path, slug]) => <Route key={path} path={`/${path}`} element={<PolicyDocument policy={policyMap[slug]} />} />)}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes><Footer /></Router></CartProvider>;
}
export default App;
